import React from 'react'
import deleteIcon from '../assets/images/delete-icon.svg';

export const DeleteButton = () => {

  return (
    <button className='btn'>
      <img src={deleteIcon} alt='Delete'/>
    </button>
  )
}
